import { connect } from 'react-redux';
import View from './AdvWorkflowSummaryView';
import { depthFirstJump } from '../AdvWorkflowActions';
import {
  hasTakeMeToPlanSelector,
  hasAddAnotherGoalSelector,
  finishButtonTextSelector,
  isInSummarySelector,
  iterator as iteratorSelector,
  currentClientId,
} from '../AdvWorkflowSelector';
import { sortedItemListOrDefaultSelector } from '../../Summaries/SummarySelector';
import withResponsiveness from '../../../CommonComponents/withResponsiveness';
import { isConsumerArea, currentClientSelector } from '../../../CommonSelectors/CommonAreaSelector';
import { externalHostSelector } from '../../../ConsumerArea/ConsumerAreaSelector';

const mapStateToProps = (state, ownProps) => ({
  currentClientId: currentClientId(state, ownProps),
  finishButtonText: finishButtonTextSelector(),
  hasTakeMeToPlan: hasTakeMeToPlanSelector(),
  hasAddAnotherGoal:
    !isConsumerArea(state) || (hasAddAnotherGoalSelector(state) && !ownProps.viewport.isMobile),
  itemList: sortedItemListOrDefaultSelector(state, ownProps),
  isInSummary: isInSummarySelector(state, ownProps),
  iterator: iteratorSelector(state, ownProps),
  goToSummaryWhenReady: ownProps.goToSummaryWhenReady,
  workflowId: ownProps.workflowId,
  outputFunction: ownProps.outputFunction,
  lastStepResponse: ownProps.lastStepResponse,
  canGoToPlan: ownProps.canGoToPlan,
  currentClient: currentClientSelector(state),
  externalHost: externalHostSelector(state),
});

const mapDispatchToProps = dispatch => ({
  goToAddAnotherGoal: clientId => () => {
    window.ADV.util.Router.go2('ClientEditPlan', {
      clientId,
    });
  },
  summaryJump: (workflowId, clientId, iterator) => {
    dispatch(depthFirstJump(workflowId, [iterator]));
  },
  onFinish: (clientId, hasTakeMeToPlan, currentClient) => () => {
    // The finish action can take us back to the all goals or display workflow done.
    // The finish action doesn't go to the
    // financial plan, that's why `Take me to my plan` button exists.
    window.ADV.util.Router.go2(
      hasTakeMeToPlan ? 'ClientEditPlan' : currentClient.ComponentName || 'WorkflowDoneV2',
      {
        clientId,
      },
    );
  },
});

export default withResponsiveness(connect(mapStateToProps, mapDispatchToProps)(View));
